import { RoutingConfig } from '@spartacus/core';

export const customRoutingConfig: RoutingConfig = {
  routing: {
    protected: true,
    routes: {
      landing: {
        paths: ['search/*'],
      },
      termsAndConditions: {
        paths: ['https://www.gea.com/de/assets/261689/'],
      },
    },
  },
};
